import LOGO from "../images/natalias.png";

export const Team__Natalias = {
  name: "Natalias",
  logoImage: LOGO,
  teamImage: null,
  teamLogoColor: "#0d7272ff",
  teamJerseyColor: "#FFBA00",

  // Stats
  gamesWon: 3,
  gamesLost: 0,
  gamesTied: 0,
  gamesTiedWon: 0,

  ownGoalsInFavor: 0,
  goalsScoredAgainst: 33 + 28 + 25,
  defaultGoals: 0,

  isChampion: false,
  isEliminated: false,

  players: [
    {
      goalsScored: 37 + 43 + 39,
    },
  ],
};
